<template>
  <div
    ref="chatContainer"
    id="chatContainer"
    class="chatContainer"
    @click="activePopoverMessageId = ''"
  >
    <div class="messagebox">
      <div v-if="imErrorVisible" class="imError">
        当前聊天会话已断开，尝试重新连接
        <div @click="reconnect" class="imError-icon">
          <SyncOutlined :spin="isSpinning" />
        </div>
      </div>
      <a-tabs
        class="messagebox-tabs"
        v-model:activeKey="activeKey"
        :style="{ height: MsgContentHeight }"
        style="width: 100%"
      >
        <template #tabBarExtraContent>
          <div class="messagebox-tabs_right">
            <div
              class="trackRecord"
              v-if="[1, 10, 39].includes(curWorkOrderType)"
              @click="showTrackRecord"
            >
              <auth-img :src="trackImg" class="trackImg" alt="" />
              患者进度跟踪
            </div>
            <div
              v-if="[5, 22, 25, 26, 33].includes(curWorkOrderType)"
              class="trackRecord"
              @click="showAIRecord"
            >
              <auth-img :src="ailog" class="trackImg" alt="" />
              AI处理流
            </div>
          </div>
        </template>
        <a-tab-pane v-for="c in chatInfoGroupTabs" :key="c.groupId" :forceRender="true">
          <template #tab>
            <a-tooltip v-if="c.groupId === weComPatientChatId" placement="bottomLeft">
              <template #title>
                <span>
                  企微触达途径仅推送重要通知、温馨关怀内容。其余药品推荐，操作引导，业务对接事宜等，烦请引导患者到小程序私聊或者让患者接听95148，保障企微渠道触达沟通合规和清晰。
                </span>
              </template>
              <a-badge :count="unReadNum[c.key] || 0" :offset="[10, -6]">
                <span class="tabTitle">{{ c.title }}</span>
              </a-badge>
            </a-tooltip>
            <a-badge v-else :count="unReadNum[c.key] || 0" :offset="[10, -6]">
              <span class="tabTitle">{{ c.title }}</span>
            </a-badge>
          </template>
          <WechatPatientChat
            v-if="c.groupId === weComPatientChatId"
            :active="activeKey === weComPatientChatId"
            :doctorId="workOrderGroupInfo?.doctorInfo?.ucUserId"
            :patientId="workOrderGroupInfo?.patientInfo?.ucUserId"
            :workOrderId="workOrderGroupInfo?.targetWorkOrder?.workOrderId"
            :eligibility="weComEligibility"
            :quoteRequest="weComQuoteRequest"
            @select-common-word="handleWeComSelectWords"
          />
          <div v-else :ref="setMessageboxRef(c.groupId)" class="messagebox-content">
            <div
              class="more-message"
              v-if="
                messageMap[c.groupId]?.length > 0 ||
                workOrderGroupInfo?.consultInfo?.consultStatus === '1'
              "
            >
              <!-- 问诊中才展示 -->
              <div class="getMoreMsg leftStatus" v-if="showRemainTimes && activeKey === groupId">
                <div class="status"></div>
                <div class="statusText">问诊中</div>
                <div class="remain">
                  (剩余
                  <span>{{ remainTimes >= 0 ? remainTimes : 0 }}</span>
                  条)
                </div>
              </div>
              <div class="getMoreMsg" v-if="newMsgTipsMap[c.groupId]?.loadText">
                <auth-img @click="loadMoreMsgs" :src="getMoreMsg" alt="" />
                <a @click="loadMoreMsgs" v-if="newMsgTipsMap[c.groupId]?.loadText">
                  {{ newMsgTipsMap[c.groupId]?.loadText }}
                </a>
                <a-input
                  v-model:value="newMsgTipsMap[c.groupId].pageSize"
                  style="width: 45px; border-radius: 4px"
                  size="small"
                  @pressEnter="loadMoreMsgs"
                />
                <span>条</span>
              </div>
              <div class="getMoreMsg rightAction">
                <a v-if="!newMsgTipsMap[activeKey]?.isScrollTop" @click="scrollTop">
                  <auth-img :src="toTop" alt="" />
                  回到顶部
                </a>
                <a v-if="!newMsgTipsMap[activeKey]?.isScrollBottom" @click="scrollBottom">
                  <auth-img :src="toBottom" alt="" />
                  返回底部
                </a>
              </div>
            </div>
            <div v-if="newMsgTipsMap[c.groupId]?.showLoading">
              <a-spin />
            </div>
            <div class="message-list" v-if="messageMap[c.groupId]?.length > 0">
              <div
                class="message-group"
                v-for="(item, index) in messageMap[c.groupId]"
                :key="item.mid"
                :id="item.mid"
              >
                <!-- 消息时间 -->
                <div
                  v-if="
                    !Config.SHIELD_MSG.includes(item.customEvent) &&
                    (index === 0 ||
                      getTimeVisible(
                        (messageMap[c.groupId] && messageMap[c.groupId][index - 1]) || {},
                        item
                      ))
                  "
                  class="time-style"
                >
                  {{ formatTime(item.time) }}
                </div>
                <!--
                  撤回消息
                -->
                <div v-if="item.msgStatus === -1" class="more-message">
                  <!-- 判断 撤回的AI消息 -->
                  <div v-if="item.customEvent === '50800'" class="more-text">
                    {{ renderRecalByAI(item, workOrderGroupInfo) }}
                    <a v-if="isAIReEedit(item)" @click="copyMessage(item.msg.textContent)">
                      重新编辑
                    </a>
                  </div>
                  <!-- 判断 撤回的AI小结消息 -->
                  <div v-else-if="item.customEvent === '29005'" class="more-text">
                    {{ renderRecalByAI(item, workOrderGroupInfo) }}
                  </div>
                  <div v-else class="more-text">
                    {{ renderRecal(item, workOrderGroupInfo) }}
                    <a
                      v-if="item.bySelf && renderEdit(item) && item.contentsType === 'txt'"
                      @click="copyMessage(item.msg)"
                    >
                      重新编辑
                    </a>
                  </div>
                </div>
                <!-- 问卷结果卡片 -->
                <div class="card" v-else-if="item.customEvent === '23020'">
                  <ScaleResults :msg="item.msg"></ScaleResults>
                </div>
                <!-- 医生打招呼特殊处理 -->
                <Tips v-else-if="item.customEvent === '50001'" :title="item.msg.toPatient" />
                <!-- 导诊绑定医生和医生助手 -->
                <Tips
                  v-else-if="['25009', '25010'].includes(item.customEvent)"
                  :title="item.msg.toDa"
                >
                  <template #addlink>
                    <span
                      style="color: #1890ff; cursor: pointer; padding: 0 0"
                      @click="
                        seeBindDetail(
                          item.msg,
                          item.customEvent === '25009' ? 'doctor' : 'assistant'
                        )
                      "
                    >
                      {{ item.msg.toDaLinkMsg }}>>
                    </span>
                  </template>
                </Tips>
                <Tips
                  v-else-if="Config.SYSTEM_MESSAGES.includes(item.customEvent)"
                  :title="item.msg.toDa"
                />
                <!-- 区分是否购买服务包 -->
                <Tips
                  v-else-if="item.customEvent === '25001'"
                  :title="
                    item.msg.msgTypeDesc === 'service_pack'
                      ? '由于患者购买了服务包，本次问诊为0元'
                      : '患者和医生的问诊已经建立，请根据实际情况做好您的服务'
                  "
                />
                <!-- 复诊提醒 -->
                <RemindCard
                  v-else-if="item.customEvent === '50550'"
                  title="医生已为患者设置复诊提醒"
                  :content="getRemindContent(item.msg)"
                />
                <!-- 医生评价卡片 -->
                <EvalutionToDoctor v-else-if="item.customEvent === '29001'" :info="item" />
                <!-- 推荐药品卡片 -->
                <ReMedicines :msg="item.msg" v-else-if="item.customEvent === '50802'"></ReMedicines>
                <!-- 购药卡片 -->
                <DrugBuyCard :msg="item.msg" v-else-if="item.customEvent === '52000'"></DrugBuyCard>
                <!-- 健管评价卡片 29401 待评价 29402 已评价-->
                <EvalutionToHelper
                  v-else-if="['29401', '29402'].includes(item.customEvent)"
                  :evaluteConfig="item"
                />
                <!-- 视频咨询结束卡片 -->
                <picVideoConsult v-else-if="item.customEvent === '50900'" :msg="item.msg" />
                <!-- 图文咨询卡片 -->
                <picTextConsult v-else-if="item.customEvent === '50020'" :msg="item.msg" />
                <!--  -->
                <template v-else-if="item.customEvent === '24004'">
                  <Tips title="患者发起的问诊还未支付"></Tips>
                </template>
                <!-- 取消问诊订单系统提示 -->
                <template v-else-if="item.customEvent === '25003'">
                  <Tips :title="item.msg.toDa || '当前问诊已结束'"></Tips>
                </template>
                <!-- 【兼容老数据】身心临观二期上线后这条消息显示处方卡片消息,老得数据还是显示【处方待审核】后面显示处方卡片 -->
                <template
                  v-else-if="item.customEvent === '22111' && isEmpty(item?.msg?.msgShowType)"
                >
                  <Tips title="处方待审核"></Tips>
                </template>
                <!-- 系统消息 -->
                <Tips
                  v-else-if="
                    !Config.SHIELD_MSG.includes(item.customEvent) &&
                    tipsMessageType.includes(item.customEvent)
                  "
                  :title="sysTitle(item)"
                >
                  <template #addlink v-if="item.customEvent === '22006'">
                    <span
                      style="color: #1890ff; cursor: pointer; padding: 0 0"
                      @click="
                        toDetail(
                          item.msg.oldRecommendId,
                          item.customEvent,
                          item.msg?.parentInstanceSn
                        )
                      "
                    >
                      处方ID：{{ item.msg.oldRecommendId }}
                    </span>
                  </template>
                </Tips>
                <!-- 卡片消息 -->
                <div
                  v-else-if="!Config.SHIELD_MSG.includes(item.customEvent)"
                  class="message-box"
                  :class="{ bySelf: item.bySelf }"
                  @dblclick.self="preventExternalClick"
                  @click.self="preventExternalClick"
                >
                  <!-- 发送人信息 -->
                  <div class="header">
                    <!-- 50702 更年期健康项目 以团长名义推送文字消息  -->
                    <auth-img
                      mode="ant"
                      :preview="false"
                      :width="44"
                      :height="44"
                      :src="
                        item.customEvent === '50702'
                          ? item.msg.teamLeaderHeadUrl || head_d
                          : renderHeader({ id: item.from, groupInfo: workOrderGroupInfo })
                      "
                    />
                  </div>
                  <div class="message-main">
                    <div class="user-name" :class="{ isSelf: item.bySelf }">
                      <span v-if="isGuideConsult">
                        {{
                          renderName(item.from, {
                            showErp: true,
                            groupInfo: workOrderGroupInfo
                          })
                        }}
                      </span>
                      <span v-else>
                        {{
                          item.customEvent === '50702'
                            ? item.msg.teamLeaderName
                            : renderName(item.from, { groupInfo: workOrderGroupInfo })
                        }}
                      </span>
                      <div
                        :style="
                          item.customEvent === '50702'
                            ? { backgroundColor: '#D6EAFF', color: '#1890FF' }
                            : renderClass(item.from)
                        "
                        class="user-title"
                        v-if="item.from !== 'aiassistantadmin'"
                      >
                        {{ item.customEvent === '50702' ? '医生' : renderTitle(item.from) }}
                      </div>
                    </div>
                    <!-- 消息主体 -->
                    <div class="message-content">
                      <!-- 群聊消息已读未读人员列表 -->
                      <div
                        :class="{ other_read_flag: !item.bySelf, self_read_flag: item.bySelf }"
                        v-if="isReadAckEnabled"
                      >
                        <div
                          v-if="
                            handleAckReadStatus(item).type === 'img' &&
                            handleAckReadStatus(item).num === 0
                          "
                        >
                          <auth-img
                            :preview="false"
                            :width="16"
                            :height="16"
                            :src="handleAckReadStatus(item).res"
                          />
                        </div>
                        <a-popover
                          v-else
                          trigger="click"
                          overlayClassName="readStatus-popover"
                          :placement="item.bySelf ? 'topRight' : 'topLeft'"
                        >
                          <template #title>
                            <div class="readPop">已读人员</div>
                          </template>
                          <template #content>
                            <div
                              class="reader"
                              v-for="(_reader, _rIndex) in hadnleReadRoles(item)"
                              :key="_rIndex"
                            >
                              {{ _reader }}
                            </div>
                          </template>
                          <span v-if="handleAckReadStatus(item).type === 'img'">
                            <auth-img
                              :preview="false"
                              :width="16"
                              :height="16"
                              :src="handleAckReadStatus(item).res"
                            />
                          </span>
                          <div v-else class="flag_num">
                            {{ handleAckReadStatus(item).res }}
                          </div>
                        </a-popover>
                      </div>
                      <!-- 图片消息 -->
                      <a-popover
                        v-if="item.contentsType === 'img'"
                        :visible="activePopoverMessageId === item.mid"
                        trigger="click"
                        :placement="item.bySelf ? 'left' : 'right'"
                        :get-popup-container="triggerNode => triggerNode.parentNode"
                      >
                        <template #content>
                          <div class="handleBtn" @click="copyImageMSG(item.msg)">复制</div>
                          <template v-if="handleImgRecall(item)">
                            <div class="handleBtn" @click="recalMessage(item)">撤回</div>
                          </template>
                          <template v-if="!item.bySelf">
                            <div class="handleBtn" @click="handleUploadLibrary(item, 1)">
                              上传量表库
                            </div>
                            <div
                              class="handleBtn"
                              @click="handleUploadLibrary(item, 2)"
                              v-if="!isGuideConsult"
                            >
                              上传检查单库
                            </div>
                          </template>
                          <div
                            v-if="activeKey === privateId"
                            class="handleBtn"
                            @click="handleUploadPrescription(item)"
                          >
                            上传处方
                          </div>
                        </template>
                        <div
                          class="message-img-box"
                          @contextmenu.prevent="handleContextMenu(item, true)"
                        >
                          <auth-img
                            mode="ant"
                            @click="setPreviewImgId(item, 'img')"
                            :width="200"
                            height="auto"
                            :src="handleImg(item.msg)"
                            :fallback="defaultImage"
                            :preview="false"
                          />
                        </div>
                      </a-popover>
                      <!-- 音频消息 -->
                      <div v-else-if="item.contentsType === 'audio'" style="height: auto">
                        <auth-img
                          mode="audio"
                          @play="setPreviewImgId(item)"
                          :src="item.msg"
                          style="background: none"
                          controls
                          menu
                        ></auth-img>
                      </div>
                      <!-- 视频消息 -->
                      <div v-else-if="item.contentsType === 'video'">
                        <auth-img mode="video" :src="item.msg" width="200" controls></auth-img>
                      </div>
                      <!-- 聊天消息 -->
                      <a-popover
                        v-else-if="item.contentsType === 'txt'"
                        :visible="activePopoverMessageId === item.mid && item.bySelf"
                        trigger="click"
                        :placement="item.bySelf ? 'left' : 'right'"
                      >
                        <template #content>
                          <a style="color: #666666" @click="recalMessage(item)">撤回</a>
                        </template>
                        <p
                          :id="item.mid + '_copy'"
                          v-on:dblclick.stop="doubleClick(item.msg, item.mid + '_copy')"
                          @contextmenu.prevent="handleContextMenu(item)"
                          v-html="renderTxt(item.msg, item.bySelf)"
                          @click="onTelClick"
                        ></p>
                      </a-popover>
                      <!-- 快捷链接聊天消息 -->
                      <a-popover
                        v-else-if="item.customEvent === '50901'"
                        :visible="activePopoverMessageId === item.mid && item.bySelf"
                        trigger="click"
                        :placement="item.bySelf ? 'left' : 'right'"
                      >
                        <template #content>
                          <a style="color: #666666" @click="recalMessage(item)">撤回</a>
                        </template>
                        <QuickLinkDialogue
                          :content-text="renderTxt(item.msg.textContent)"
                          :btn-name="JSON.parse(item.msg.toPatientEvents)[0].eventName"
                          :id="item.mid + '_copy'"
                          v-on:dblclick.stop="doubleClick(item.msg, item.mid + '_copy')"
                          @contextmenu.prevent="handleContextMenu(item)"
                        />
                      </a-popover>
                      <!-- 需要使用html展示，并且是气泡展示 -->
                      <div v-else-if="Config.HTML_MESSAGES.includes(`${item.customEvent}`)">
                        <PartnerHospitalBindingDoctor
                          v-if="
                            ['50500'].includes(item.customEvent) && isPartnerHospitalMsg(item.msg)
                          "
                          :msg="item?.msg"
                        />
                        <FirstBindingDoctor
                          v-else-if="['50500', '50503'].includes(item.customEvent)"
                          :msg="item?.msg"
                          :customEvent="parseInt(item.customEvent)"
                          :doctorName="workOrderGroupInfo?.doctorInfo?.username"
                        />
                        <!-- 新版五要素-->
                        <FiveElements
                          v-else-if="['53001'].includes(item.customEvent)"
                          :msg="item?.msg"
                          :customEvent="parseInt(item.customEvent)"
                          :doctorName="workOrderGroupInfo?.doctorInfo?.username"
                        />
                        <div v-else v-html="item.msg.msg"></div>
                      </div>
                      <div class="aiMsgs" v-if="['50501'].includes(item.customEvent)">
                        {{ item.msg.question }}
                      </div>
                      <!--                      需要排除快捷链接的类型-->
                      <a-popover
                        v-else-if="
                          item.contentsType === 'custom' && !['50901'].includes(item.customEvent)
                        "
                        :visible="activePopoverMessageId === item.mid && item.bySelf"
                        trigger="click"
                        :placement="item.bySelf ? 'left' : 'right'"
                      >
                        <template #content>
                          <a style="color: #666666" @click="recalMessage(item)">撤回</a>
                        </template>
                        <p
                          v-if="item.customEvent === '50702'"
                          :id="item.mid + '_copy'"
                          v-on:dblclick.stop="doubleClick(item.msg.msgContent, item.mid + '_copy')"
                          @contextmenu.prevent="handleContextMenu(item)"
                          v-html="renderTxt(item.msg.msgContent, item.bySelf)"
                          @click="onTelClick"
                        ></p>
                        <!-- 卡片消息 -->
                        <div v-else @contextmenu.prevent="handleContextMenu(item)">
                          <Card
                            :isBySelf="item.bySelf"
                            :msgObject="item.msg || {}"
                            :customEvent="item.customEvent"
                            @chatEvents="handleChatEvents"
                            :msgBody="item"
                            :isGroup="activeKey === groupId"
                          />
                        </div>
                      </a-popover>
                      <div v-if="item.customEvent === '50702'">
                        <div class="message-bottom-tips">
                          引用：
                          <span
                            v-for="(snItem, snIndex) in prescriptionSnList(
                              item.msg?.prescriptionSn
                            )"
                            class="message-tips-text"
                            :key="snItem"
                            @click="() => handleTreatmentPlan(snItem)"
                          >
                            {{
                              `${
                                prescriptionSnList(item.msg?.prescriptionSn)?.length > 1
                                  ? `治疗方案${snIndex + 1}`
                                  : '治疗方案'
                              }${
                                prescriptionSnList(item.msg?.prescriptionSn)?.length === snIndex + 1
                                  ? ''
                                  : '，'
                              }`
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>

      <div class="messagbox-float" v-if="showFloatMsg">
        <FloatMsgRender
          v-if="showFloatMsg === 1"
          :workOrderGroupInfo="workOrderGroupInfo"
          @floatActionByType="handleFloatMsgActionV2"
        />
        <DocRegisterOrder
          v-if="showFloatMsg === 2"
          :groupInfo="workOrderGroupInfo"
          :groupId="doctorDaGroupId"
          @hideRegisterEnter="handleRefresh"
        />
      </div>

      <div
        class="messagebox-footer z-flex-c talk-notAllow"
        v-if="activeKey !== weComPatientChatId && canAssTalk"
      >
        {{ onTalkReason }}
      </div>
      <div class="messagebox-footer" v-else-if="activeKey !== weComPatientChatId">
        <div
          class="new_mgs_pop"
          v-if="newMsgTipsMap[activeKey]?.visible && newMsgTipsMap[activeKey]?.num"
          @click="handleNewMsgTips"
        >
          <auth-img :src="moreMsg" />
          {{ newMsgTipsMap[activeKey]?.num > 99 ? '99+' : newMsgTipsMap[activeKey]?.num }}条新消息
        </div>
        <div class="footer-icon">
          <div class="icon-left">
            <template v-if="activeKey === guideConsultGroupId">
              <EmojiPicker :emojis="recentEmoji" @selectEmoji="insertEmoji" />
              <UpLoadImage
                :chatId="activeKey"
                :chatToType="chatToType"
                :groupTabsSelKey="groupTabsSelKey"
              />
              <!-- 推荐医生 -->
              <RecommendDoctor
                v-if="showDoctorIcon"
                :workOrderGroupInfo="workOrderGroupInfo"
                :groupId="activeKey"
                :privateId="privateId"
                @chatWithDoc="startDoctorChat"
              />
              <!-- 量表 -->
              <Gauge
                :workOrderGroupInfo="workOrderGroupInfo"
                :chatId="activeKey"
                :surveySource="1"
              />
              <!-- 健康信息 -->
              <HealthInfo
                :workOrderGroupInfo="workOrderGroupInfo"
                :groupId="activeKey"
              ></HealthInfo>
              <!-- 话术库 -->
              <CommonWords @selectWords="selectWords" ref="commonWordRef" />
            </template>
            <template v-else-if="[groupId, privateId].includes(activeKey)">
              <EmojiPicker :emojis="recentEmoji" @selectEmoji="insertEmoji" />
              <!-- 1.上传图片组件 -->
              <UpLoadImage
                :chatId="activeKey"
                :chatToType="chatToType"
                :groupTabsSelKey="groupTabsSelKey"
              />
              <!-- 2.量表 -->
              <Gauge :workOrderGroupInfo="workOrderGroupInfo" :chatId="activeKey" />
              <!-- 3.检查单 -->
              <CheckList :groupType="activeKey === privateId ? 2 : 1" :chatId="activeKey" />
              <!-- 4.问诊提醒 -->
              <consult-notify />
              <!-- 5.导诊导医 -->
              <leadingExamining :workOrderGroupInfo="workOrderGroupInfo" :groupId="groupId || 0" />
              <!-- 6.复诊预约 -->
              <ChatAppoint :groupId="activeKey" />
              <!-- 7.添加小结组件（只有私聊才有） -->
              <addSummary
                :workOrderGroupInfo="workOrderGroupInfo"
                :privateId="privateId"
                @changeTab="setActiveTabsKey(groupId)"
                v-if="activeKey === privateId"
              />
              <!-- 8.话术库 -->
              <CommonWords @selectWords="selectWords" ref="commonWordRef" />
              <!-- 推荐医生 只有导诊群或患者私聊展示 -->
              <RecommendDoctor
                v-if="activeKey === privateId && showDoctorIcon"
                :workOrderGroupInfo="workOrderGroupInfo"
                :groupId="activeKey"
                :privateId="privateId"
                @chatWithDoc="startDoctorChat"
              />
              <!-- 9.预诊病历 -->
              <PreMedicalRecord :workOrderGroupInfo="workOrderGroupInfo" />
              <!-- 10.快捷链接 （只有私聊才有）-->
              <QuickLink
                v-if="activeKey === privateId"
                :groupId="activeKey"
                :workOrderGroupInfo="workOrderGroupInfo"
              />
              <GuidePatientJoinWeCom
                v-if="activeKey === privateId"
                :ucDoctorId="workOrderGroupInfo?.doctorInfo?.ucUserId"
                :ucPatientId="workOrderGroupInfo?.patientInfo?.ucUserId"
                :workOrderId="workOrderGroupInfo?.targetWorkOrder?.workOrderId"
                :chatId="activeKey"
                :chatToType="chatToType"
              />
              <!-- 9.疗效跟踪 -->
              <!-- <CurativeTrack
                  :workOrderGroupInfo="workOrderGroupInfo"
                  v-if="activeKey === privateId"
                /> -->
            </template>
            <template v-else>
              <EmojiPicker :emojis="recentEmoji" @selectEmoji="insertEmoji" />
              <UpLoadImage
                :chatId="activeKey"
                :chatToType="chatToType"
                :groupTabsSelKey="groupTabsSelKey"
              />
              <CommonWords @selectWords="selectWords" ref="commonWordRef" />
              <Patient :workOrderGroupInfo="workOrderGroupInfo" />
            </template>
          </div>
          <a-button @click="onSendTextMsg" type="primary">发送</a-button>
        </div>
        <div class="footer-send">
          <a-popover
            trigger=""
            placement="topLeft"
            overlayClassName="chat-popover"
            v-model:visible="visiblePopover"
          >
            <template #content>
              <CommonWordsPopover
                class="wordPopover"
                :keyword="keyword"
                @handlePick="handlePick"
                :commonwordsList="commonwordsList"
                @closePopover="closePopover"
                :visible="visiblePopover"
              />
            </template>
            <contenteditable
              ref="editor"
              class="send-text"
              tag="div"
              :contenteditable="true"
              v-model="message"
              :tabindex="0"
              :no-nl="false"
              :no-html="false"
              @blur="saveSelection"
              @focus="restoreSelection"
              @keydown="handleKeydown"
              data-placeholder="请输入消息内容后按Enter键发送"
              :activeKey="activeKey"
            />
          </a-popover>
        </div>
      </div>
      <AI @exportMessage="handleAIExportMessage" ref="aiRef" />
    </div>
    <div class="info-box">
      <Info
        ref="infoRef"
        :loading="spinning"
        v-bind="$attrs"
        v-if="activeKey"
        :workOrderGroupInfo="workOrderGroupInfo"
        @finishChat="finishChat"
        @pChat="startPatientChat"
        @chatWithDoc="startDoctorChat"
        @handleRefresh="handleRefresh"
        :activeGroupKey="activeKey"
        :isPatChat="activeKey === privateId"
      />
    </div>
    <uploadLibrary
      @cancelLibrary="handleCancelLibrary"
      :params="libraryParams"
      :chatId="activeKey"
    />
    <SetRetreatment
      ref="treatmentRef"
      @showSupplement="suppplmentMRCallback"
      @handleRefresh="handleRefresh"
    />
    <!-- 诊疗记录弹窗部分 -->
    <medicalRecordsPoup
      ref="medicalRecordsPoupRef"
      :visible="supplementMRecord.uploadRecordVisible"
      :params="supplementMRecord.query"
      @cancelClick="supplementMRecord.onClose"
      :id="supplementMRecord.uploadRecordId"
      @savaData="supplementMRecord.refreshOffLineRecord"
      :needAPI="needAPI"
    ></medicalRecordsPoup>
    <!-- 线下处方弹窗 -->
    <the-detail
      v-model:visible="theDetailVisible"
      :id="prescriptionId"
      :serialNumber="serialNumber && serialNumber.length === 1 ? '' : serialNumber"
      :recordType="recordType"
    />
    <!-- 图片预览组件 -->
    <ImageViewer
      :visible="imageViewerVisible"
      :imageList="srcList"
      :currentId="previewImgId"
      @setVisible="setImageViewerVisible"
      ref="imageViewerRef"
    />
    <!-- 绑定医生详情 -->
    <BindDetailInfo
      ref="bindDetailInfoRef"
      v-bind="$attrs"
      :activeGroupKey="activeKey"
      :isPatChat="activeKey === privateId"
      :isChatSession="true"
      @chatWithDoc="getDoctorInfo(curGroupInfo)"
      @updateRemark="handlebindDetailInfoUpdateRemark"
    />
    <!-- 专属医生助手 -->
    <BindAssistent ref="bindAssistentRef" />
    <!-- 患者进度跟踪 -->
    <TrackRecord :workOrderGroupInfo="workOrderGroupInfo" ref="trackRecordRef" />
    <AIRecord :workOrderId="curGroupInfo.targetWorkOrder.workOrderId" ref="AIRecordRef" />
    <!-- 沟通小结 -->
    <a-modal
      title="AI生成小结"
      :visible="summaryPanelVisible"
      @cancel="
        () => {
          summaryPanelVisible = false
          handleRefresh()
        }
      "
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
    >
      <summaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible = false"
      />
    </a-modal>
  </div>
</template>

<script setup>
import Config from '@/config/index'
import { useStore } from 'vuex'
import { message as Message, Modal } from 'ant-design-vue'
import { callOut } from '@/utils/Tccc'
import { identifyCalleeByPhone } from '@/api/login'
import { roleMap } from '@/components/Tccc/config'
import {
  watch,
  ref,
  reactive,
  nextTick,
  computed,
  onMounted,
  onBeforeUnmount,
  createVNode
} from 'vue'
import { SyncOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import FirstBindingDoctor from './components/FirstBindingDoctor/index.vue'
import FiveElements from './components/FiveElements/index.vue'
import PartnerHospitalBindingDoctor from './components/partnerHospitalBindingDoctor/index.vue'
import ScaleResults from './components/ScaleResults/index.vue'
import { isEmpty } from '@/utils'
import {
  UpLoadImage,
  AddSummary,
  CommonWords,
  RecommendDoctor,
  HealthInfo,
  SummaryPannel,
  LeadingExamining,
  // CurativeTrack,
  Gauge,
  // Plan,
  ConsultNotify,
  ChatAppoint,
  CheckList,
  CommonWordsPopover,
  uploadLibrary,
  AI,
  FloatMsgRender,
  SetRetreatment,
  EmojiPicker,
  contenteditable,
  Tips,
  RemindCard,
  Card,
  EvalutionToDoctor,
  EvalutionToHelper,
  Info,
  Patient,
  DocRegisterOrder,
  ImageViewer,
  BindDetailInfo,
  TrackRecord,
  AIRecord,
  BindAssistent,
  PreMedicalRecord,
  QuickLink,
  QuickLinkDialogue,
  WechatPatientChat,
  GuidePatientJoinWeCom
} from './components'
import {
  useDraftsMsg,
  useCommonWords,
  useReadStatus,
  useChatInfoGroup,
  useChatAction,
  useWorkOrder,
  useImagePreview,
  useWechatPatientEligibility
} from './hooks'
import {
  handleImg,
  subStringToType,
  formatTime,
  renderClass,
  renderTitle,
  renderName,
  renderHeader
} from '@/utils'
import TheDetail from '@/components/TheDetail/index.vue'
import moment from 'moment'
import trackImg from '@/assets/img/track.png'
import ailog from '@/assets/img/ai/ai-log.png'

import { isShowRecommendDoctor } from '@/api/chat'
import { haveProcessingOrder } from '@/api/workPlace/workOrder'
import { apiOrderOperateHistory } from '@/api/workPlace/retreatment.js'
import getCurrentGroupInfo from '@/views/hooks/getCurrentGroupInfo'
import medicalRecordsPoup from '@/views/HealthRecord/HealthInfo/common/medicalRecordsPoup.vue'
import moreMsg from '@/assets/img/chat/more_msg.png'
import { initWorkOrder } from '@/views/WorkPlace/hooks/workOrder'
import { computeGroupId } from '@/views/WorkPlace/components/WorkOrder/components/hooks/useGroupOrder'
import {
  REFRESH_MAIN,
  REFRESH_LIST,
  CLOSE_CURRENT_IM,
  FINISH_ORDER
} from '@/views/WorkPlace/handleEventBuss'
import head_d from '@/assets/img/chat/head_d.png'
import picTextConsult from './components/message/picTextConsult.vue'
import picVideoConsult from './components/message/picVideoConsult.vue'
import ReMedicines from './components/message/ReMedicines/index.vue'
import DrugBuyCard from './components/message/DrugBuyCard/index.vue'
import { chatGroupTabsKeyEnum } from '@/utils/globalMap'
import { updateMatters } from '@/api/HealthRecord/index.js'

const {
  isGuideConsult,
  workOrderGroupInfo,
  curGroupInfo,
  curWorkOrderType,
  showRemainTimes,
  remainTimes,
  getConsultDetail
} = useWorkOrder()
const {
  groupTabsSelKey,
  groupId,
  privateId,
  guideConsultGroupId,
  doctorDaGroupId,
  weComPatientChatId,
  activeKey,
  messageMap,
  chatInfoGroupTabs,
  messageboxRefs,
  newMsgTipsMap,
  setMessageboxRef,
  queryHistoryMessage,
  lastMsgToGroupId,
  generateConversationList,
  setWeComPatientChatVisible,
  loadMoreMsgs
} = useChatInfoGroup()
const {
  eligibility: weComEligibility,
  checkEligibility: checkWeComEligibility,
  resetEligibility: resetWeComEligibility
} = useWechatPatientEligibility()

// 原有会话先初始化；只有患者私聊或问诊会话存在时，才异步判断微信 Tab 准入资格。
const initializeWeComPatientTab = async () => {
  setWeComPatientChatVisible(false)
  resetWeComEligibility()
  const hasEntryConversation = chatInfoGroupTabs.value.some(tab =>
    [chatGroupTabsKeyEnum.患者私聊, chatGroupTabsKeyEnum.问诊会话].includes(tab.key)
  )
  if (!hasEntryConversation) return

  const result = await checkWeComEligibility({
    ucDoctorId: workOrderGroupInfo.value?.doctorInfo?.ucUserId,
    ucPatientId: workOrderGroupInfo.value?.patientInfo?.ucUserId
  })
  if (result) setWeComPatientChatVisible(true)
}
const chatToType = computed(() => {
  const isGuide = activeKey.value === guideConsultGroupId.value
  const isPublic = activeKey.value === groupId.value
  return isGuide ? 'guide' : isPublic ? 'public' : 'private'
})

const { getActivedMsg, saveActivedMsg, saveFile } = useDraftsMsg(activeKey.value)
const {
  visiblePopover,
  commonWordRef,
  commonwordsList,
  keyword,
  recentEmoji,
  message,
  editor,
  aiRef,
  onSendTextMsg,
  handleInput,
  saveSelection,
  restoreSelection,
  insertEmoji,
  focusEditor,
  closePopover,
  copyMessage,
  renderTxt,
  doubleClick,
  handleKeydown,
  handlePick,
  selectWords,
  upDateNum,
  exportMessage,
  preventExternalClick,
  getGroupTabKey
} = useCommonWords(activeKey, chatToType, saveFile, chatInfoGroupTabs)
const {
  // defineUnReadNum,
  unReadNum,
  allGroupMsgList,
  computedUnRead,
  handleAckReadStatus,
  hadnleReadRoles,
  clearGroupIdFromCache,
  clearUnReadGroupCache
} = useReadStatus(activeKey)
const {
  imageViewerRef,
  imageViewerVisible,
  previewImgId,
  srcList,
  getImgMsgUrls,
  setPreviewImgId,
  setImageViewerVisible
} = useImagePreview(activeKey)
const {
  tipsMessageType,
  isSpinning,
  isReadAckEnabled,
  recallData,
  defaultImage,
  imErrorVisible,
  activePopoverMessageId,
  getMoreMsg,
  toTop,
  toBottom,
  reconnect,
  handleContextMenu,
  renderEdit,
  getPatientInfo,
  getDoctorInfo,
  startPatientChat,
  startDoctorChat,
  getTimeVisible,
  upChatHandle,
  handleNewMsgTips,
  handleImgRecall,
  getScrollHeight,
  recalMessage,
  renderRecal,
  renderRecalByAI,
  copyImageMSG,
  scrollBottom,
  scrollTop,
  setActiveTabsKey
} = useChatAction(
  messageMap,
  newMsgTipsMap,
  messageboxRefs,
  activeKey,
  privateId,
  doctorDaGroupId,
  imageViewerRef,
  imageViewerVisible,
  chatInfoGroupTabs,
  queryHistoryMessage,
  getConsultDetail
)
const medicalRecordsPoupRef = ref(null)
// const selImage = ref(false)
// 系统消息的文案
const sysTitle = item => {
  const { customEvent, msg } = item
  let text = Config.TIPS_MESSAGE_TYPE[customEvent]
  // 针对处方药材不足做出的消息调整
  if (customEvent === '22006' && msg.isInventoryMessageFlag) {
    // item.isInventoryMessageFlag
    text = msg.inventoryMessage || text
  }
  return text
}
// 沟通小结弹窗
const summaryPanelVisible = ref(false)
const chatSummaryId = ref('')

const needAPI = ref(false)
const weComQuoteRequest = ref({ id: 0, text: '' })
const handleWeComSelectWords = record => {
  if (record?.id) upDateNum(record.id)
}
const handleAIExportMessage = text => {
  if (activeKey.value === weComPatientChatId.value) {
    weComQuoteRequest.value = { id: Date.now(), text }
    return
  }
  exportMessage(text)
}
// 0标识不显示，1显示悬浮类消息，2显示推送BD工单入口
const showFloatMsg = computed(() => {
  if (activeKey.value === weComPatientChatId.value) return 0
  return isFloatOrderType()
})
const MsgContentHeight = computed(() => {
  // 企微会话的 footer 位于独立模块内部，不需要为外部 IM footer 再预留 200px
  if (activeKey.value === weComPatientChatId.value) {
    return '100%'
  }
  if (showFloatMsg.value) {
    return 'calc(100% - 242px)'
  } else {
    return 'calc(100% - 200px)'
  }
})
const spinning = ref(false)
const store = useStore()

const prescriptionSnList = str => {
  const resultArray = str.split(',').map(item => item.trim())
  return resultArray
}

// 处理复诊提醒文案
const getRemindContent = remidData => {
  const { planEndDateForDA = '' } = remidData || {}
  let content = ''
  if (planEndDateForDA) {
    const time = moment(planEndDateForDA).format('MM月DD日')
    content = `系统将在${time}向您发送复诊提醒。`
  }
  return content
}
//线下处方详情弹窗
const theDetailVisible = ref(false)
//线下处方观察处方笺号
// const { serialNumber = '' } = workInfo
const serialNumber = ref('')
//西药 中药 辅助方
// const prescriptionVisible = ref(false)
const recordType = ref('')
const prescriptionId = ref(-1)

// 是否展示推荐医生卡片
const showDoctorIcon = ref(true)
const getIsShowRecommendDoctor = () => {
  isShowRecommendDoctor()
    .then(res => {
      showDoctorIcon.value = res
    })
    .catch(() => {
      showDoctorIcon.value = true
    })
}

// 导诊群中 非导诊咨询工单健管不可说话
const canAssTalk = computed(() => {
  if (
    curWorkOrderType.value &&
    guideConsultGroupId.value &&
    activeKey.value === guideConsultGroupId.value
  ) {
    return [10, 39].includes(curWorkOrderType.value) ? false : true
  }
  return false
})

// 场景1：未绑定医生但是不是导诊工单的导诊私聊
// 场景2：已绑定医生的导诊私聊非导诊工单
const onTalkReason = computed(() => {
  const { doctorInfo = {} } = curGroupInfo.value
  return doctorInfo.ucUserId && curWorkOrderType.value !== 10
    ? '患者已绑定医生系统结束导诊服务窗口，如有需要请进入患者私聊进行沟通。'
    : '您暂未处理导诊工单，故无法通过导诊入口发送消息'
})

//悬浮消息逻辑
function isFloatOrderType() {
  const {
    targetWorkOrder
    // dealWorkOrderList
  } = workOrderGroupInfo.value
  const floatMsgVisible =
    Object.keys(Config.FLOAT_WORK_ORDER).map(Number).includes(targetWorkOrder.businessType) &&
    activeKey.value !== doctorDaGroupId.value &&
    targetWorkOrder.quickDealNavigationDisplayFlag === 1
  // 工单 完成/失效 的话那么直接隐藏
  // const dealWorkOrder = dealWorkOrderList.find(
  //   order => order.workOrderId === targetWorkOrder.workOrderId
  // )
  // 39 特殊处理
  const followRemark = [39].includes(targetWorkOrder.businessType)
  const remark = targetWorkOrder.quickDealNavigationBusinessFollowRemark
  const followRemarkVisible = followRemark ? remark : true
  let dealWorkOrderState = ![1, 3, 6, 7].includes(targetWorkOrder.stateTag)
  // 待购工单特殊处理
  if (targetWorkOrder.businessType === 5) {
    dealWorkOrderState = true
  }
  const floatVisible = floatMsgVisible && dealWorkOrderState && followRemarkVisible

  const showPushDocRegisterOrder =
    activeKey.value === doctorDaGroupId.value &&
    targetWorkOrder.businessType === 34 &&
    !targetWorkOrder.hideStatus

  return floatVisible ? 1 : showPushDocRegisterOrder ? 2 : 0
}

const trackRecordRef = ref(null)
const showTrackRecord = () => {
  trackRecordRef.value.showDrawer()
}
const AIRecordRef = ref(null)
const showAIRecord = () => {
  // workOrderGroupInfo.value.targetWorkOrder
  // curGroupInfo.value.targetWorkOrder.workOrderId
  AIRecordRef.value.showDrawer()
}
// 查看绑定的医生
const bindDetailInfoRef = ref(null)
const bindAssistentRef = ref(null)

const seeBindDetail = (ctx, type) => {
  console.log('ctx', ctx)
  const id = type === 'doctor' ? ctx.ucDoctorId : ctx.bdUcUserId
  if (type === 'doctor') {
    const { ucDoctorId, doctorId } = ctx
    const detailParams = {
      ucDoctorId,
      doctorId
    }
    bindDetailInfoRef.value.initModal(detailParams, type)
  } else {
    bindAssistentRef.value.initModal(id, type)
  }
}

// 问诊会话、患者私聊、医生私聊切换
const chatControler = computed(() => store.state.app.chatToControler)
watch(
  () => chatControler.value,
  val => {
    if (val.type === 'public') {
      activeKey.value = groupId.value
    } else {
      if (val.receiver === 'patient') {
        activeKey.value = privateId.value
      } else {
        doctorDaGroupId.value
          ? (activeKey.value = doctorDaGroupId.value)
          : getDoctorInfo(curGroupInfo.value)
      }
    }
  },
  {
    deep: true
  }
)

// 聊天容器点击：清空气泡弹层 + 识别手机号拨号链接
// 点击消息内手机号：识别 data-tel 后二次确认外呼（由各消息容器 @click 调用，非顶层委托）
const onTelClick = e => {
  const telEl = e.target.closest?.('[data-tel]')
  if (!telEl) return
  e.preventDefault()
  handleTelClick(telEl.getAttribute('data-tel'))
}
// 调起外呼（聊天手机号与自定义拨打复用）：用识别接口返回的被叫信息发起外呼
// 参数映射与 FloatingCallButton 的 doCall 保持一致（仅 workOrderIds 保留聊天工单关联）
const doCallOut = (data, phone) => {
  if (!phone) return
  const targetWorkOrder = workOrderGroupInfo.value?.targetWorkOrder || {}
  const p = {
      calleeType: data.calleeType,
      calleeUcUserId: data.calleeUcUserId,
      doctorId: data.doctorId,
      patientType: data.patientType,
      // 聊天场景保留工单关联
      workOrderIds: [targetWorkOrder.workOrderId],
      phone: data.phone || phone
    },
    userInfo = {
      // 优先用接口返回的 userTypeName（中文；roleMap 中 0=系统 错位，故兜底在其后）
      userType: data.userTypeName || roleMap[data.calleeType] || '',
      name: data.name || ''
    }
  callOut(p, userInfo).then(result => {
    if (result.cdrId) {
      const params = {
        cdrId: result.cdrId,
        serviceMatters: '',
        mattersRemark: ''
      }
      updateMatters(params)
    }
  })
}

// 点击手机号：先识别被叫，用识别结果构造二次确认框，确定后外呼
const handleTelClick = async phone => {
  if (!phone) return
  try {
    const data = await identifyCalleeByPhone({ phone })
    const calleePhone = data.phone || phone
    const content = data.name
      ? `确定给${data.userTypeName || '用户'}-${data.name}（${calleePhone}）拨打电话吗？`
      : `确定给未知用户（${calleePhone}）拨打电话吗？`
    Modal.confirm({
      icon: createVNode(ExclamationCircleOutlined),
      title: '提示',
      content: content,
      okText: '拨打',
      cancelText: '取消',
      onOk: () => doCallOut(data, phone)
    })
  } catch (e) {
    Message.warning('号码识别失败，暂不支持拨打')
  }
}

const handleTreatmentPlan = prescriptionId => {
  theDetailVisible.value = true
  serialNumber.value = prescriptionId
  recordType.value = 'prescriptionGroup'
}

//患者复诊日程弹窗
const treatmentRef = ref(null)
//补充诊疗记录
const supplementMRecord = reactive({
  uploadRecordId: null,
  uploadRecordVisible: false,
  query: {},
  onClose: () => {
    supplementMRecord.uploadRecordVisible = false
  },
  refreshOffLineRecord: async (type, args) => {
    supplementMRecord.uploadRecordVisible = false
    // 增加了患者复诊日程回调逻辑 treatmentRef弹窗是否打开
    if (treatmentRef.value.retreatmentVisible) {
      console.log('患者复诊日程开启中', type, args)
      treatmentRef.value.receiveSupplementParams(args)
    } else {
      await apiOrderOperateHistory({
        operationBusinessId: curGroupInfo.value.targetWorkOrder.workOrderId,
        operationName: curGroupInfo.value?.curDocAss.username,
        operationDesc: ''
      })
      handleRefresh()
    }
  }
})

const suppplmentMRCallback = args => {
  const { doctorInfo = {}, patientInfo = {} } = curGroupInfo.value
  supplementMRecord.query = {
    ucPatientId: patientInfo.ucUserId,
    ucDoctorId: doctorInfo.ucUserId,
    reserveEntry: 3
  }
  supplementMRecord.uploadRecordId = args
  supplementMRecord.uploadRecordVisible = true
  needAPI.value = false
}

//悬浮消息触发事件集（废弃）
// const handleFloatMsgAction = async (workOrderType, args) => {
//   if (workOrderType === 26 || workOrderType === 23) {
//     const { doctorInfo = {}, patientInfo = {} } = curGroupInfo.value
//     supplementMRecord.query = {
//       ucPatientId: patientInfo.ucUserId,
//       ucDoctorId: doctorInfo.ucUserId,
//       reserveEntry: 3
//     }
//     workOrderType === 23 && (supplementMRecord.uploadRecordId = args)
//     supplementMRecord.uploadRecordVisible = true
//     needAPI.value = true
//   } else if (workOrderType === 25 && args?.type === 'text') {
//     try {
//       const { ctxBusinessId, workOrderId } = args
//       const data = (await getSmsTemplateByReserveId({ reserveId: ctxBusinessId })) || {}
//       Modal.confirm({
//         title: () => '发送短信',
//         content: () => data,
//         width: 520,
//         okText: '确定发送',
//         cancelText: '取消',
//         async onOk() {
//           try {
//             const params = {
//               reserveId: ctxBusinessId,
//               workOrderId
//             }
//             const { code } = (await sendSms(params)) || {}
//             if (code === 0) {
//               handleRefresh()
//             }
//           } catch (error) {
//             console.log(error)
//             Modal.destroyAll()
//           }
//         },
//         onCancel() {}
//       })
//     } catch (error) {
//       console.log(error)
//     }
//   } else if (workOrderType === 5) {
//     const ctxBusinessId = workOrderGroupInfo.value.targetWorkOrder.quickDealNavigationBusinessId
//     // AI的问诊小结快速定位
//     summaryPanelVisible.value = true
//     chatSummaryId.value = ctxBusinessId
//   } else {
//     treatmentRef.value.treatmentInit(workOrderType, args)
//   }
// }
//悬浮消息触发事件集（全部都去AI小结）
const handleFloatMsgActionV2 = async (isAI, workOrderType, args) => {
  if (isAI) {
    const ctxBusinessId = workOrderGroupInfo.value.targetWorkOrder.quickDealNavigationBusinessId
    // AI的问诊小结快速定位
    summaryPanelVisible.value = true
    chatSummaryId.value = ctxBusinessId
  } else {
    treatmentRef.value.treatmentInit(workOrderType, args)
  }
}
// 是否可以重新编辑
const isAIReEedit = computed(() => item => {
  let ans = false
  const hasMy = item.operationUsers?.find(
    user => user.ucUserId === store.getters.userId && user.role === 4 && user.operationType === 3
  )
  const isAImsg = item.contentsType === 'custom' && item.customEvent === '50800'
  if (!isAImsg || !hasMy) return false
  ans = renderEdit(item)
  return ans
})
const handleChatEvents = ctxCusEvent => {
  const { doctorInfo = {}, patientInfo = {} } = curGroupInfo.value
  switch (ctxCusEvent) {
    case '21020':
      supplementMRecord.query = {
        ucPatientId: patientInfo.ucUserId,
        ucDoctorId: doctorInfo.ucUserId,
        reserveEntry: 2
      }
      supplementMRecord.uploadRecordVisible = true
      needAPI.value = true
      break
    default:
      break
  }
}

// 初始化群组消息
const initHistoryMsg = res => {
  const {
    groupId,
    assistantPatientGroupId,
    guideConsultGroupId,
    doctorDaGroupId,
    groupType,
    doctorPatientGroupId
  } = res
  if (
    !groupId &&
    !assistantPatientGroupId &&
    !guideConsultGroupId &&
    !doctorDaGroupId &&
    !doctorPatientGroupId
  )
    return
  select(
    groupId,
    assistantPatientGroupId,
    guideConsultGroupId,
    doctorDaGroupId,
    groupType,
    doctorPatientGroupId
  )
}

//监听tab切换
watch(
  () => activeKey.value,
  newValue => {
    if (newValue === weComPatientChatId.value) {
      groupTabsSelKey.value = chatGroupTabsKeyEnum.微信私聊患者
      return
    }
    // 获取当前选中key的数据
    groupTabsSelKey.value = getGroupTabKey(newValue)
    //清除工单未读消息混存
    clearGroupIdFromCache(activeKey.value)
    message.value = getActivedMsg(activeKey.value)
    // Object.assign(unReadNum, defineUnReadNum)
    // 设置最新的 groupId
    store.commit('group/SET_DEALING_GROUPID', newValue)
    const hasMsg = messageMap[newValue]?.length > 0
    // 群聊
    if (!hasMsg) {
      if (!newMsgTipsMap[newValue]) return
      newMsgTipsMap[newValue].page = 1
      newMsgTipsMap[newValue].loadText = '向上加载'
      newMsgTipsMap[newValue].showLoading = true
      newMsgTipsMap[newValue].reloadNewMsg = true
    }
    // 私聊
    if (newValue === privateId.value) {
      getPatientInfo(workOrderGroupInfo.value, !hasMsg)
    } else if (newValue === doctorDaGroupId.value) {
      getDoctorInfo(curGroupInfo.value, !hasMsg)
    } else if (newValue === groupId.value || newValue === guideConsultGroupId.value) {
      if (hasMsg) return
      queryHistoryMessage(newValue, 1)
    }
  }
)

// 同步当前正在处理的企微工单；聚合会话内切换目标工单时也需要更新
watch(
  [() => activeKey.value, () => workOrderGroupInfo.value?.targetWorkOrder?.workOrderId],
  ([currentChatId, workOrderId]) => {
    store.commit(
      'workOrder/SET_ACTIVE_WE_COM_WORK_ORDER_ID',
      currentChatId === weComPatientChatId.value ? workOrderId : ''
    )
  },
  { immediate: true }
)

//监听群聊消息接收
watch(
  () => store.state.chat.msgList.group,
  newValue => {
    if (activeKey.value === weComPatientChatId.value) return
    messageMap[activeKey.value] = newValue[activeKey.value]
    allGroupMsgList.value = newValue
    unReadNum.guideConsultGroupId = computedUnRead(guideConsultGroupId.value)
    unReadNum.groupId = computedUnRead(groupId.value)
    unReadNum.privateId = computedUnRead(privateId.value)
    unReadNum.doctorDaGroupId = computedUnRead(doctorDaGroupId.value)
    upChatHandle(messageMap[activeKey.value])
  },
  { deep: true }
)

onMounted(() => {
  REFRESH_MAIN?.on(handleRefresh)
  FINISH_ORDER?.on(finishChat)
  getIsShowRecommendDoctor()
  nextTick(() => {
    focusEditor()
  })
})

onBeforeUnmount(() => {
  REFRESH_MAIN?.off()
  FINISH_ORDER?.off()
  store.commit('group/SET_DEALING_GROUPID')
  messageboxRefs[activeKey.value]?.removeEventListener('scroll', getScrollHeight)
})

const libraryParams = reactive({
  visible: false,
  type: 1,
  filePath: '',
  sendName: '',
  sendPersonId: null
})
// 患者发送的图片上传量表库
const handleUploadLibrary = (item, type) => {
  libraryParams.visible = true
  libraryParams.type = type
  libraryParams.filePath = item.msg
  libraryParams.sendName = renderName(item.from, { groupInfo: workOrderGroupInfo.value })
  libraryParams.sendPersonId = item.from
}
const handleCancelLibrary = () => {
  libraryParams.visible = false
  activePopoverMessageId.value = ''
}

// NOTE:结束会话（完成任务时调用，删除对应群id下面的消息）
async function finishChat() {
  // 需要判断这个群聊下面是否还存在处理中工单
  const { doctorInfo = {}, patientInfo = {} } = workOrderGroupInfo.value || {}
  const params = {
    ucPatientId: patientInfo.ucUserId,
    ucDoctorId: doctorInfo.ucUserId
  }
  const res = await haveProcessingOrder(params)
  if (!res) {
    const groupIds = [
      groupId.value,
      privateId.value,
      guideConsultGroupId.value,
      doctorDaGroupId.value
    ]
    store.dispatch('clearAllMsg', groupIds)
    initWorkOrder()
  } else {
    REFRESH_LIST?.emit()
    handleRefresh()
  }
}
function handleRefresh() {
  spinning.value = true
  // isEmpty.value = true
  const currentActiveKey = activeKey.value
  getCurrentGroupInfo().then(res => {
    activeKey.value = currentActiveKey
    const dealWorkOrderList = res?.workOrderGroupInfo?.dealWorkOrderList || []
    if (!dealWorkOrderList.length) {
      CLOSE_CURRENT_IM?.emit()
      return
    }
    const tipMessage = res?.workOrderGroupInfo?.tipMessage || ''
    spinning.value = false
    // isEmpty.value = false
    tipMessage && Message.warning(tipMessage)
  })
}

//监听当前聊天窗消息变更
watch(
  () => store.state.chat.currentMsgs,
  newValue => {
    if (activeKey.value === weComPatientChatId.value) return
    messageMap[activeKey.value] = newValue
    newMsgTipsMap[activeKey.value].showLoading = false
    upChatHandle(newValue)
  },
  { deep: true }
)
//会话信息集合
const select = (
  newGroupId,
  newPrivateId,
  newGuideGroupId,
  newDoctorDaGroupId,
  groupType,
  doctorPatientGroupId
) => {
  message.value = getActivedMsg(activeKey.value)
  //设置tabs
  generateConversationList(
    newGroupId,
    newPrivateId,
    newGuideGroupId,
    newDoctorDaGroupId,
    groupType,
    doctorPatientGroupId
  )
  initializeWeComPatientTab()
  lastMsgToGroupId(groupId.value, doctorDaGroupId.value, privateId.value, guideConsultGroupId.value)
    .then(lastMsg => {
      activeKey.value = lastMsg.to
    })
    // 异常处理
    .catch(() => {
      activeKey.value = computeGroupId(
        newGuideGroupId,
        newGroupId,
        newDoctorDaGroupId,
        newPrivateId,
        groupType
      )
    })
}

watch(
  () => message.value,
  val => {
    if (!val) {
      visiblePopover.value = false
    }
    saveActivedMsg(activeKey.value, val)
    handleInput(val)
  }
)

// NOTE:入口监听到工单和群聊的关联关系
watch(
  () => curGroupInfo.value,
  val => {
    workOrderGroupInfo.value = val || {}
    initHistoryMsg(val)
    //获取问诊详情
    getConsultDetail(val)
    // 重置工单对应群未读缓存
    clearUnReadGroupCache()
  },
  {
    deep: true,
    immediate: true
  }
)
// 点击续方ID，跳转至处方详情
const toDetail = (recommandId, customEvent, parentInstanceSn) => {
  switch (customEvent) {
    case '22006':
      if (parentInstanceSn) {
        serialNumber.value = parentInstanceSn
        recordType.value = subStringToType(parentInstanceSn)
        prescriptionId.value = recommandId
        theDetailVisible.value = true
        return
      }
      // R:线上处方  H:健康辅助方  HR:线下处方
      serialNumber.value = ''
      recordType.value = subStringToType('R')
      prescriptionId.value = recommandId
      theDetailVisible.value = true
      break
    default:
      break
  }
}
const infoRef = ref(null)
// 绑定人员详情协同备注
const handlebindDetailInfoUpdateRemark = () => {
  infoRef.value.getRemark()
}

// 打开上传处方ocr识别引导弹窗
const handleUploadPrescription = item => {
  const imageUrl = item.msg
  console.log('imageUrl', imageUrl, item)
  handleOrcUpload()
  nextTick(() => {
    medicalRecordsPoupRef.value?.triggerOcrFromUrl(imageUrl)
  })
}

// 上传处方OCR识别回调
const handleOrcUpload = () => {
  const { doctorInfo = {}, patientInfo = {} } = curGroupInfo.value
  supplementMRecord.query = {
    ucPatientId: patientInfo.ucUserId,
    ucDoctorId: doctorInfo.ucUserId,
    reserveEntry: 1
  }
  supplementMRecord.uploadRecordVisible = true
  needAPI.value = true
}

watch(
  () => messageMap[activeKey.value],
  newValue => {
    if (activeKey.value === weComPatientChatId.value) return
    const { contentsType, mid } = recallData.value
    // 撤回消息
    if (mid && contentsType === 'img')
      srcList.value.splice(
        srcList.value.findIndex(item => item.msgId === mid),
        1
      )
    // 环信查询会有延迟 2s后再请求接口
    setTimeout(() => {
      getImgMsgUrls()
    }, 2000)
    if (newValue?.length === 0) return
    nextTick(() => {
      messageboxRefs[activeKey.value]?.addEventListener('scroll', getScrollHeight)
    })
  },
  { deep: true, immediate: true }
)
// 判断是否为合作医院消息
const isPartnerHospitalMsg = msg => {
  const content = msg?.msg || ''
  return /\*95148\*/.test(content)
}
</script>
<style lang="scss">
.tel-link {
  color: #1890ff;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.chat-popover {
  width: 800px;
}

.readStatus-popover {
  width: 120px;

  .ant-popover-inner {
    background-color: #333333 !important;
    border-radius: 5px;
  }

  .ant-popover-arrow {
    display: none;
  }

  .ant-popover-title {
    min-width: 120px;
    border-bottom: 1px solid #575757;
    padding: 8px 0;
  }

  .readPop {
    width: 100%;
    font-weight: 400;
    color: #999999;
    text-align: center;
  }

  .reader {
    font-weight: 400;
    text-align: center;
    color: #fff;
    margin-bottom: 10px;
  }

  .reader:last-of-type {
    margin-bottom: 0px;
  }
}

.floatMsg-popover {
  .ant-popover-inner {
    background-color: #333333 !important;
    color: #fff !important;
    border-radius: 5px !important;
  }

  .ant-popover-arrow {
    display: none;
  }
}

.message-bottom-tips {
  background-color: #1a1a1a08;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  color: #5c5c5c;
  display: inline-block;

  .message-tips-text {
    color: #3f64ff;
    cursor: pointer;
  }
}

.pic-text-card {
  display: flex;
  justify-content: center;
}
.pic-text-consult {
  background-image: linear-gradient(180deg, #e2eefb 0%, #ffffff 36%);
  border-radius: 13px;
  width: 408px;
  padding: 12px 16px 14px 16px;
  .header {
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 2px solid #f5f5f5;
    .picIcon {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #1b1b1b;
    }
  }

  .body {
    display: flex;
    align-items: center;
    padding-top: 14px;
    font-weight: 400;
    font-size: 16px;
    color: #333;
    .label {
      color: #999;
      margin-right: 16px;
    }
    .name {
      max-width: 40%;
      margin-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tag {
      min-width: 12%;
      padding: 4px 8px;
      margin-left: 10px;
      border-radius: 8px;
      background: #f3f7ff;
      font-weight: 400;
      font-size: 14px;
      color: #7e8698;
    }
  }
}
</style>
<style lang="scss" scoped>
@import './index.scss';
</style>
